<template>
    <div class="lw-course-pay-options lw-body-bg">

        <div class="lw-padding-normal">
            <h2 class="learnworlds-heading learnworlds-subheading-large learnworlds-element">
                Enroll in this course / Payment options
            </h2>
        </div>

        <label class="lw-padding-normal lw-course-pay-option with-flexible-parts align-items-center justify-content-space-between lw-bt-1px-fadeout80" @click="setSelectedOption('course',titleId)">

            <div class="flexible-part with-flexible-parts">
                <div class="flexible-part">
                    <input type="radio" :id="titleId" name="coursePaymentOptions" checked>
                    <div class="lw-course-pay-option-circle lw-light-bg lw-b-1px-fadeout80"></div>
                </div>
                <div class="flexible-part">
                    <h3 class="learnworlds-heading learnworlds-heading3-large learnworlds-element">
                        {{title}}
                    </h3>
                </div>
            </div>
            <div class="flexible-part learnworlds-align-right" v-if="discountFlag">
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal lw-deleted-price lw-text-color-fadeout20 no-margin-bottom" >{{currencySymbol}}{{price}}</div>
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large"><strong>{{currencySymbol}}{{discountPrice}}</strong></div>
            </div>
            <div class="flexible-part learnworlds-align-right" v-else>
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large"><strong>{{currencySymbol}}{{price}}</strong></div>
            </div>

        </label>


        <label class="lw-padding-normal lw-course-pay-option with-flexible-parts justify-content-space-between lw-bt-1px-fadeout80" v-for="paymentPlan in paymentPlans" v-if="showPaymentPlans" @click="setSelectedOption('paymentPlan',paymentPlan.id)">

            <div class="flexible-part with-flexible-parts">
                <div class="flexible-part">
                    <input type="radio" :id="'paymentPlans_'+ paymentPlan.id" name="coursePaymentOptions">
                    <div class="lw-course-pay-option-circle lw-light-bg lw-b-1px-fadeout80"></div>
                </div>
                <div class="flexible-part">
                    <h3 class="learnworlds-heading no-margin-bottom learnworlds-heading3-large learnworlds-element">
                        {{paymentPlan.name}}
                    </h3>
                    <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element" v-if="paymentPlan.type === 'with_upfront'">
                        <strong>{{currencySymbol}}{{paymentPlan.firstAmount}}</strong> {{$t('common.upfront')}}  {{$t('common.and')}} {{paymentPlan.paymentsCount - 1}}<strong></strong>  {{$t('common.payments_of')}}<strong>{{currencySymbol}}{{paymentPlan.amount}} / {{getPaymentPlanSubscriptionInterval(paymentPlan.subscriptionIntervalType)}}</strong>.
                    </div>

                    <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-text-color-fadeout50" v-if="paymentPlan.type === 'with_upfront'">
                        {{getPaymentPlanSubscriptionSecondDate(paymentPlan)}}
                    </div>

                    <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element" v-else-if="paymentPlan.type === 'without_upfront'">
                        <strong>{{paymentPlan.paymentsCount}} </strong> {{$t('common.payments_of')}} <strong>{{currencySymbol}}{{paymentPlan.amount}} / {{getPaymentPlanSubscriptionInterval(paymentPlan.subscriptionIntervalType)}}</strong>.
                    </div>
                </div>
            </div>
            <div class="flexible-part learnworlds-align-right">
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large no-margin-bottom"><strong>{{currencySymbol}}{{getPaymentPlanTotalAmount(paymentPlan)}}</strong></div>
                <div  class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal">{{getPaymentPlanTotalDuration(paymentPlan)}}</div>
            </div>

        </label>


        <label class="lw-padding-normal lw-course-pay-option with-flexible-parts justify-content-space-between lw-bt-1px-fadeout80" v-for="subscription in subscriptions" v-if="showSubscriptions" @click="setSelectedOption('subscription',subscription.titleId)">

            <div class="flexible-part with-flexible-parts">
                <div class="flexible-part">
                    <input type="radio" :id="'sub_' + subscription.titleId" name="coursePaymentOptions">
                    <div class="lw-course-pay-option-circle lw-light-bg lw-b-1px-fadeout80"></div>
                </div>
                <div class="flexible-part">
                    <h3 class="learnworlds-heading no-margin-bottom learnworlds-heading3-large learnworlds-element">
                        {{subscription.title}}
                    </h3>
                    <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                        {{subscription.courses.length}} {{$t('common.courses')}}
                            <a :href=" optionsUseHref ? '/subscriptions?id='+ subscription.titleId : 'javascript:void(0)'" v-show="showDetails" @click.stop>{{$t('course.details')}}</a>
                    </div>
                </div>
            </div>
            <div class="flexible-part learnworlds-align-right">
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large no-margin-bottom"><strong>{{currencySymbol}}{{subscription.price}}</strong></div>
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal">/ {{getSubscriptionInterval(subscription)}}</div>
            </div>

        </label>

        <label class="lw-padding-normal lw-course-pay-option with-flexible-parts justify-content-space-between lw-bt-1px-fadeout80" v-for="bundle in bundles" v-if="showBundles" @click="setSelectedOption('bundle',bundle.titleId)">

            <div class="flexible-part with-flexible-parts">
                <div class="flexible-part">
                    <input type="radio" :id="'bundle_' + bundle.titleId" name="coursePaymentOptions">
                    <div class="lw-course-pay-option-circle lw-light-bg lw-b-1px-fadeout80"></div>
                </div>
                <div class="flexible-part">
                    <h3 class="learnworlds-heading no-margin-bottom learnworlds-heading3-large learnworlds-element">
                        {{bundle.title}}
                    </h3>
                    <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                        {{bundle.courses.length}} {{$t('common.courses')}}
                        <a  :href=" optionsUseHref ? '/bundles?bundle_id='+ bundle.titleId : 'javascript:void(0)'" v-show="showDetails" @click.stop>{{$t('course.details')}}</a>
                    </div>
                </div>
            </div>
            <div class="flexible-part learnworlds-align-right" v-if="bundle.discountFlag">
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal lw-deleted-price lw-text-color-fadeout20 no-margin-bottom" >{{currencySymbol}}{{bundle.price}}</div>
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large"><strong>{{currencySymbol}}{{bundle.discount_price}}</strong></div>
            </div>
            <div class="flexible-part learnworlds-align-right" v-else>
                <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large"><strong>{{currencySymbol}}{{bundle.price}}</strong></div>
            </div>
        </label>


        <div class="lw-padding-normal lw-course-pay-option lw-bt-1px-fadeout80">

            <div class="learnworlds-button-wrapper lw-content-block learnworlds-element">
                <a class="learnworlds-button learnworlds-element learnworlds-button-normal learnworlds-button-solid-accent1" @click="purchaseButtonClicked" :href="selectedOptionHref">
                    <span>{{$t('common.ads_enroll')}}</span>
                </a>
            </div>
        </div>


    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "PaymentPlansLayout1",
        mixins: [ComponentTemplatesMixin],
        data () {
            return {
                selectedOptionType : '',
                selectedOptionProductId : ''
            }
        },
        props: {
            bundles : {
                type: Array
            },
            subscriptions : {
                type: Array
            },
            paymentPlans : {
                type: Array
            },
            currencySymbol : {
                type: Array
            },
            title : {
                type: String
            },
            titleId : {
                type: String
            },
            discountFlag : {
                type: Boolean
            },
            discountPrice : {
                type: Number
            },
            price : {
                type: Number
            },
            showDetails : {
                type: Boolean
            },
            showBundles : {
                type: Boolean
            },
            showSubscriptions : {
                type: Boolean
            },
            showPaymentPlans : {
                type: Boolean
            },
            optionsUseHref : {
                type: Boolean
            },

        },
        computed: {
            selectedOptionHref () {
                if (!this.optionsUseHref) {
                    return 'javascript:void(0)';
                }

                if (this.selectedOptionType === 'subscription') {
                    return `/payment?product_id=${this.selectedOptionProductId}&type=subscription`
                }

                if (this.selectedOptionType === 'bundle') {
                    return `/payment?product_id=${this.selectedOptionProductId}&type=bundle`
                }

                if (this.selectedOptionType === 'paymentPlan') {
                    return `/payment?product_id=${this.titleId}&type=course&plan_id=${this.selectedOptionProductId}`
                }

                return `/payment?product_id=${this.titleId}`;
            }
        },
        methods: {

            setSelectedOption (type , id) {
                this.selectedOptionType = type;
                this.selectedOptionProductId = id;
            },
            getPaymentPlanSubscriptionInterval (intervalType) {
                let paymentPlanIntervals = {
                    '14-day' :  "2" + this.$t('common.weeks'),
                    '1-month' :  this.$t('common.month'),
                    '3-month' : "3" + this.$t('common.months'),
                    '6-month' : "6" + this.$t('common.months'),
                }

                return paymentPlanIntervals[intervalType] || '';
            },
            getSubscriptionInterval (subscription) {
                if (subscription.interval > 1) {
                    return subscription.interval + ' ' + this.$t('common.' + subscription.interval_type + "s");
                }

                return this.$t('common.'+ subscription.interval_type);
            },
            getPaymentPlanSubscriptionSecondDate (paymentPlan) {

                if (paymentPlan.subscriptionTrialType && paymentPlan.subscriptionTrialDays ) {
                    return paymentPlan.subscriptionTrialDays > 1 ?
                        this.$t('common.second_payment_is_on') + ' ' + paymentPlan.subscriptionTrialDays + ' ' + this.$t('common.days') :
                        this.$t('common.second_payment_is_on') + ' ' + paymentPlan.subscriptionTrialDays + ' ' + this.$t('common.day');
                } else if (paymentPlan.subscriptionTrialType == 'date' && paymentPlan.subscriptionTrialDate) {
                    return formatDT(new Date(paymentPlan.subscriptionTrialDate * 1000), "date-month");
                }

                return  '';
            },
            getPaymentPlanTotalAmount: function(paymentPlan){
                let finalPrice = 0;

                if(paymentPlan.type == 'without_upfront'){
                    finalPrice = parseFloat(paymentPlan.amount) * parseInt( paymentPlan.paymentsCount );
                } else{
                    finalPrice = parseFloat(paymentPlan.firstAmount) + (parseFloat(paymentPlan.amount) * (parseInt((paymentPlan.paymentsCount - 1))));
                }

                if(isNaN(finalPrice)){
                    finalPrice ='';
                }
                return finalPrice;
            },
            getPaymentPlanTotalDuration (paymentPlan) {
                let durationNumber = 0;
                let durationInterval = '';

                let paymentPlanIntervals = {
                    '14-day' :  0.5,
                    '1-month' :  1,
                    '3-month' : 3,
                    '6-month' : 6
                }

                if(paymentPlan.type == 'without_upfront'){
                    durationNumber = paymentPlanIntervals[paymentPlan.subscriptionIntervalType] * paymentPlan.paymentsCount;
                } else{
                    durationNumber = paymentPlanIntervals[paymentPlan.subscriptionIntervalType] * ( paymentPlan.paymentsCount - 1 );
                }

                durationInterval = durationNumber > 1 ? this.$t("common.months") : this.$t("common.month");
                return durationNumber + ' ' +  durationInterval;
            },
            purchaseButtonClicked () {

                console.log("purchaseButtonClicked: " ,)
            }
        }
    }
</script>

